/* -------------------------------------------------------------------------- */
/*                                Step item styles                */
/* -------------------------------------------------------------------------- */

@import './bq-step-item.variables';

:host {
  --bq-icon--color: theme(stroke.icon.primary);

  @apply box-border inline-flex;
}

:host([orientation='vertical']) {
  @apply flex flex-1;
}

:host([orientation='vertical'][is-last]) {
  @apply flex-[0_0_auto];
}

.bq-step-item {
  @apply flex gap-s rounded-m border-none bg-transparent pe-[--bq-steps--gap] ps-0 p-b-xs2 focus-visible:focus hover:bg-hover-ui-secondary;
  @apply transition-colors duration-300;
}

.bq-step-item__prefix.dot,
.bq-step-item__prefix.icon {
  ::slotted(bq-icon) {
    --bq-icon--color: var(--bq-step-item--prefix-color);
  }

  &.current {
    ::slotted(bq-icon) {
      --bq-icon--color: var(--bq-step-item--prefix-color-current);
    }
  }

  &.completed {
    ::slotted(bq-icon) {
      --bq-icon--color: var(--bq-step-item--prefix-color-completed);
    }
  }

  &.error {
    ::slotted(bq-icon) {
      --bq-icon--color: var(--bq-step-item--prefix-color-error);
    }
  }

  &.disabled {
    ::slotted(bq-icon) {
      opacity: 0.6;
    }
  }
}

.bq-step-item__prefix.numeric {
  @apply flex items-center justify-center rounded-full;
  @apply bg-[--bq-step-item--prefix-num-bg-color] bs-[--bq-step-item--prefix-num-size] is-[--bq-step-item--prefix-num-size];
  @apply text-m font-semibold leading-regular text-primary;

  &.small {
    @apply text-s [--bq-step-item--prefix-num-size:--bq-spacing-l];
  }

  // Status

  &.current {
    @apply bg-[var(--bq-step-item--prefix-color-current)] text-alt;
  }

  &.completed {
    @apply bg-ui-success-alt text-success;
  }

  &.error {
    @apply bg-ui-danger-alt text-danger;
  }

  &.disabled {
    @apply opacity-60;
  }
}

.bq-step-item__content--description::slotted(*) {
  @apply text-s leading-regular opacity-60;
}
